// This is a modal for Adminreferralstwo

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";

export default function ModalAdminreferralstwo({ onClose }) {
  return (
    <RootWrapperModalAdminreferralstwo>
      <Overlay>
        <Wrapper>
          <Frame1392>
            <IconFilled
              src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/aec371cc-2317-4771-97b1-c6e365840fa1"
              alt="icon"
            />
          </Frame1392>
          <StatusUpdate>
            <Left>
              <Frame58>
                <Frame1391>
                  <Frame1527>
                    <Frame1527_0001>
                      <ChangeStatus>Change Status</ChangeStatus>
                    </Frame1527_0001>
                  </Frame1527>
                  <PleaseUpdateTheStatusOfThisReferralBasedOnCurrentInformation>
                    Please update the status of this referral based on current
                    information.
                  </PleaseUpdateTheStatusOfThisReferralBasedOnCurrentInformation>
                </Frame1391>
                <Frame1391>
                  <PRTNR.Select
                    label="Status"
                    options={[
                      { value: "option1", label: "Option 1" },
                      { value: "option2", label: "Option 2" },
                      { value: "option3", label: "Option 3" },
                    ]}
                  />

                  <PrtnrTextarea>
                    <GFieldsStacked_0001>
                      <Frame5>
                        <FieldLabel>Notes</FieldLabel>
                      </Frame5>
                      <Field_0001 />
                    </GFieldsStacked_0001>
                  </PrtnrTextarea>
                </Frame1391>
                <Frame59>
                  <AIMEButton
                    size="small"
                    onClick={() => alert("Cancel clicked")}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      background: "rgb(241, 245, 249)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(33, 37, 67)",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Cancel
                    </span>
                  </AIMEButton>

                  <AIMEButton
                    size="small"
                    onClick={() => alert("Update clicked")}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      gap: "10px",
                      borderRadius: "48px",
                      width: "240px",
                      background: "rgb(97, 98, 197)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Update
                    </span>
                  </AIMEButton>
                </Frame59>
              </Frame58>
            </Left>
          </StatusUpdate>
        </Wrapper>
      </Overlay>
    </RootWrapperModalAdminreferralstwo>
  );
}

const RootWrapperModalAdminreferralstwo = styled.div`
  position: relative;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  position: absolute;
  left: calc((calc((50% + 0px)) - 329px));
  top: 0px;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;

const Frame1392 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  height: 1px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const IconFilled = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const StatusUpdate = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 610px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 610px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1527 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1527_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 610px;
  box-sizing: border-box;
`;

const ChangeStatus = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  width: 612px;
  flex: 1;
`;

const PleaseUpdateTheStatusOfThisReferralBasedOnCurrentInformation = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame5 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const FieldLabel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const PrtnrTextarea = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  height: 212px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  align-self: stretch;
  height: 212px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Field_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  height: 186px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
